<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="uniteDeMesureSvc"></yo-generic-datagrid-pn>
